export const logs_action = {};
	logs_action.ACTION_ACCOUNT = { id:1, label:"Account" };
	logs_action.ACTION_AGENT = { id:5, label:"User" };
	logs_action.ACTION_ORGANIZER = { id:2, label:"Organizing brand" };
	logs_action.ACTION_PROMOTION = { id:3, label:"Promotion" };
	logs_action.ACTION_SWEEP = { id:4, label:"Giveaway" };
	logs_action.ACTION_SUBSCRIPTION = { id:6, label:"Subscription" };
	logs_action.ACTION_INVOICE_PLAN = { id:7, label:"Invoice Plan" };
	logs_action.ACTION_USER= { id:8, label:"User" };
	logs_action.ACTION_EMAIL= { id:9, label:"Email" };
	logs_action.ACTION_IP= { id:10, label:"IP" };
	logs_action.ACTION_DOMAIN= { id:11, label:"Domain" };

export const logs_type = {};
	logs_type.TYPE_CREATE = { id:1, label:"Create" };
	logs_type.TYPE_DELETE = { id:2, label:"Delete" };
	logs_type.TYPE_ACTIVATE = { id:3, label:"Activate" };
	logs_type.TYPE_DISABLE = { id:13, label:"Disable" };
	logs_type.TYPE_CHANGE = { id:4, label:"Change" };
	logs_type.TYPE_LOGIN = { id:5, label:"Login" };
	logs_type.TYPE_LOGOUT = { id:6, label:"Logout" };
	logs_type.TYPE_FINALIZED = { id:7, label:"Finalized" };
	logs_type.TYPE_REMOVE_PARTICIPANTS = { id:8, label:"Remove participants" };
	logs_type.TYPE_ASSIGN_ROLE = { id:9, label:"Assign role" };
	logs_type.TYPE_REMOVE_ROLE = { id:10, label:"Remove role" };
	logs_type.TYPE_REACTIVATE_SUBSCRIPTION = { id:11, label:"Reactivate" };
	logs_type.TYPE_CANCEL_SUBSCRIPTION = { id:12, label:"Cancel" };
	logs_type.TYPE_BLOCK = { id:14, label:"Block" };
	logs_type.TYPE_UNBLOCK = { id:15, label:"UnBlock" };

export const agent_roles = {};
	agent_roles.ROLE_ADMIN = { id:1, label:"Administrator" };
	agent_roles.ROLE_MANAGER = { id:2, label:"Manager" };
	agent_roles.ROLE_EDITOR = { id:3, label:"Editor" };
	agent_roles.ROLE_BASIC_EDITOR = { id:6, label:"Basic Editor" };
	agent_roles.ROLE_DESIGNER = { id:4, label:"Designer" };
	agent_roles.ROLE_ANALYST = { id:5, label:"Analyst" };
	agent_roles.ROLE_ANNOUNCER = { id:7, label:"Announcer" };
	agent_roles.ROLE_PREMODERATOR = { id:8, label:"Pre-moderator" };

export const account_industry = [
		{id:'advertising_and_marketing', label:"Advertising and Marketing"},
		{id:'babies_and_children', label:"Babies and children"},
		{id:'culture_and_shows', label:"Culture and shows"},
		{id:'education', label:"Education"},
		{id:'fashion', label:"Fashion"},
		{id:'food_and_beverage', label:"Food and beverage"},
		{id:'health_and_beauty', label:"Health and beauty"},
		{id:'hotel_and_catering', label:"Hotel and catering"},
		{id:'house_and_garden', label:"House and garden"},
		{id:'insurances_and_financial_services', label:"Insurances and financial services"},
		{id:'media_and_communication', label:"Media and communication"},
		{id:'pets_and_animals', label:"Pets and animals"},
		{id:'shopping_centers_and_malls', label:"Shopping centers and malls"},
		{id:'sports_and_leisure', label:"Sports and leisure"},
		{id:'technology_and_apps', label:"Technology and apps"},
		{id:'transport_and_travel', label:"Transport and Travel"},
		{id:'others', label:"Others"}
	];

export const account_company_size = [
		{id:'small_agency_or_freelance', label:"Marketing agency with less than 20 employees or freelancer"},
		{id:'large_agency', label:"Marketing agency with more than 20 employees"},
		{id:'small_brand', label:"Business with less than 50 employees"},
		{id:'large_brand', label:"Business with more than 50 employees"},
	];

